import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/RED_long.png'


const _withScopeId = n => (_pushScopeId("data-v-2ec3d8a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-dark" }
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-3" }, "Seriously nice coils", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " The beating heart of the game. Royston Electromechanical Devices (RED) is a UK manufacturer of beautiful pinball coils.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "my-4" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Highest quality materials. Exactingly wound. Mechanically strong. Cool running. Multiple connection options for easier maintenance. Custom windings, gauges, and sizes if you ask nicely 😉.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "my-4" }, null, -1))
const _hoisted_8 = { class: "lead text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "my-4" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "my-4" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "center-block red-long"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-dark g-form",
  id: "get-updates"
}, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://docs.google.com/forms/d/e/1FAIpQLSeD8vyCKCe_7_MZfbnFT49BZBzTAA3YcQFoljlM-uej_yZaHw/viewform?embedded=true",
    width: "100%",
    height: "2400px",
    frameborder: "0",
    marginheight: "0",
    marginwidth: "0"
  }, "Loading…")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("p", null, [
          _createTextVNode("Come try the "),
          _createVNode(_component_RouterLink, { to: "pinfest" }, {
            default: _withCtx(() => [
              _createTextVNode("games running our coils")
            ]),
            _: 1
          }),
          _createTextVNode(" at Pinfest 2023")
        ]),
        _hoisted_7,
        _createElementVNode("p", _hoisted_8, [
          _withDirectives((_openBlock(), _createBlock(_component_router_link, {
            to: "/",
            class: "btn btn-danger btn-lg mr-4",
            role: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Get updates")
            ]),
            _: 1
          })), [
            [_directive_scroll_to, '#get-updates']
          ]),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "btn btn-danger btn-lg",
            role: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Learn more")
            ]),
            _: 1
          })
        ]),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11
      ])
    ]),
    _hoisted_12
  ], 64))
}